/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-12-07 18:03:00
 */
export default {
  lang: "孟加拉语",
  common: {
    name1: "কার্ড তৈরি করুন",
    name2: "র‍্যাঙ্কিং তালিকা",
    name3: "শেয়ার করুন এবং লাইক পান। ",
    name4: "আপনি লাইক XX পেয়েছেন ",
    name5: "আপনি এখন শীর্ষ X এ. চালিয়ে যান। ",
    name6: "বেশি লাইক জোগাড় করুন। ",
    name7: "আপনার তথ্য জমা দিন ",
    name8: "নাম ",
    name9: "ফোন ",
    name10: "দেশ ",
    name11: "সেভ",
    name12: "",
    name13:"প্রথমে আপনার শুভেচ্ছা লিখুন",
    name14:"২৩০ অক্ষর সীমাবদ্ধ ",
    name15:"উপহার পেতে আপনার তথ্য জমা দিতে ভুলবেন না",
    name16:"১।আপনার বন্ধুকে শুভেচ্ছা বার্তা পাঠান আর বেশি লাইকের জন্য শেয়ার করুন। ",
    name17:"২।  যদি আপনি সর্বোচ্চ লাইক পান তাহলে আপনি আইফোন ১২ জিতবেন। ",
    name18:"৩। টপ ১০০ এর মধ্যে থাকলে আপনিও একটি উপহার পাবেন। ",
    name19:"শুভ বড়দিন! আইফোন জিততে শুভেচ্ছা জানান। ",
    name20:"আপনার পছন্দমত একটি কার্ড বাছাই করুন ",
    name21:"শিরোনাম ",
    name22:"তৎপর 9",
  },
  rules: {
    name1: "ফোন ১২ মিনি ",
    name2: "মোবাইল রিচার্জ",
    name3: "১ জিবি ",
    name4: "১০০ এমবি ",
    name5: "উপহার",
    name6: "যেভাবে অংশগ্রহণ করবেন ঃ ",
    name7: "১। আপনার পছন্দ অনুযায়ী একটি কার্ড বাছাই করুন এবং আপনার শুভেচ্ছা লিখুন। ",
    name8: "২। লাইক পাওয়ার জন্য কার্ডটি আপনার বন্ধুদের সাথে শেয়ার করুন ",
    name9: " ৩। যে বেশি লাইক পাবে সে আইফোন ১২ মিনি জিতবে",
    name10: "৪।  টপ ১০০ এর মধ্যে থাকলে আপনিও একটি উপহার পাবেন।",
    name11: "র‍্যাঙ্কিং তালিকা",
    name12: "গিফটের তালিকা ",
    name13:"টপ ১ ",
    name14:"আইফোন ১২ মিনি (৬৪ জিবি)",
    name15:"টপ ২- টপ ১০ ",
    name16:"",
    name17:"টপ ১১- টপ ৫০ ",
    name18:"১ জিবি",
    name19:"টপ ৫১- টপ ১০০",
    name20:"১০০ এমবি ",
    name21:"নোটঃ ",
    name22:"১। কেবল কার্লকেয়ার অ্যাকাউন্ট যাদের আছে তারা অংশগ্রহন করতে পারবে, অ্যাকাউন্ট না থাকলে আগে রেজিস্টার করুন। ",
    name23:"২। আপনি উপহার জিতে থাকলে আপনার তথ্য কন্টেস্ট চলাকালীন সময়সিমার মধ্যে জমা দিন । নাহলে আপনার উপহার বাতিল হয়ে যাবে। ",
    name24:"৩। আপনার কোন সমস্যা অথবা তথ্য জানার থাকলে দয়া করে আমাদের সাথে যোগাযোগ করুন। Carlcarelucky@gmail.com",
    name25:"৪। কার্লকেয়ার চূড়ান্ত ব্যাখ্যার অধিকার সংরক্ষণ করে।",
    name26:"শুভ বড়দিন- শুভেচ্ছা জানিয়ে আইফোন ১২ মিনি জিতুন!",
    name27:"শুভ বড়দিন ",
    name28:"কন্টেস্ট রুল ",
    name29:"ঠিক আছে",
    name30:"আপগ্রেড ",
    name31:"কন্টেস্ট উপভোগ করতে আপগ্রেড করুন ",
    name32:"লগইন ",
    name33:"দয়া করে প্রথমে লগইন করুন। ",
    name34:"গেম ওভার ",
    name35:"আপনি পেয়েছেন",
    name36:"লাইকস",
    name37:"আমার শুভেচ্ছা",
    name38:"পান",
    name39:"র‍্যাঙ্ক ",
    name40:"আইডি ",
    name41:"রুলস ",
    name42:"এখন আপনি টপ  XXX এ আছেন ",
    name43:"চালিয়ে যান!! ",
    name44:"কার্ড ",
    name45:"দয়া করে সম্পূর্ণ তথ্য পুরন করুন ",
    name46:"আপনি সফলভাবে তথ্য পুরন করেছেন। ",
    name47:"শুভ বড়দিন!- আইফোন ১২ জিততে লাইক জোগাড় করুন! ",
  },
};